import React, { Component } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router'
import css from './style.css'

const mapStateToProps = (state, ownProps) => {
  return {
    currentUser: state.currentUser
  }
}

class LoggedOut extends Component {
  componentWillMount () {
    if (this.props.currentUser && this.props.currentUser.id) {
      this.redirectToApp()
    }
  }

  componentWillReceiveProps (nextProps) {
    if (this.props.currentUser && nextProps.currentUser.id) {
      this.redirectToApp()
    }
  }

  redirectToApp () {
    this.props.router.push('/')
  }

  render () {
    return (
      <div className={css.container}>
        <div className={css.background} />
        <div className={css.content}>
          {this.props.children}
        </div>
      </div>
    )
  }
}

export default connect(mapStateToProps)(withRouter(LoggedOut))



// WEBPACK FOOTER //
// ./src/containers/logged-out/index.js